import {del, get, post, put} from './index';

const localMode = process.env.REACT_APP_LOCAL_MODE === 'true';

//#region Exports
export const getD365Exports = async () => {
    let exports = [];

    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(require('./mock-data/d365_exports.json'));
            }, 200);
        });
    } else {
        exports = await get(`/d365_get_exports`);
    }

    return exports;
};

export const createD365Export = async (exportType, dateFilter, projectCodes, workerIds) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 1000);
        });
    }

    const res = await post(`/d365_create_export`, {
        exportType,
        dateFilter,
        projectCodes,
        workerIds
    });
    return await res.json();
};

export const updateD365ExportLoadStatus = async (id, loadStatus) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 1000);
        });
    }

    return await put(`/d365_update_export`, {
        id,
        loadStatus
    });
};

export const downloadD365Export = async (id) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 1000);
        });
    }

    const res = await post(`/d365_download_export`, {id});
    return await res.json();
};

export const resubmitD365Export = async (id) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 1000);
        });
    }
    const res = await post(`/d365_resubmit_export`, {id});
    return await res.json();
}

export const getD365HourLogs = async (id) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(require('./mock-data/d365_hour_logs.json'));
            }, 200);
        });
    } else {
        const res = await post(`/d365_get_hour_logs`, {id: id});
        return await res.json();
    }
};

export const getD365HourLogPeriods = async () => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(require('./mock-data/d365_hour_log_periods.json'));
            }, 200);
        });
    } else {
        const res = await post('/d365_get_hour_log_periods');
        return await res.json();
    }
};

export const downloadD365BackupSummary = async (id) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 1000);
        });
    }

    const res = await post(`/d365_download_backup`, {id});
    return await res.json();
};

export const d365ProjectSearch = async(projectCode, includeIncomplete ) => {
    if (localMode) {
        return new Promise( resolve => {
            setTimeout(()=>{
                resolve(() => {
                    resolve(require('./mock-data/d365_project_search.json'));
                })
            },200)
        })
    }
    return await post('/d365_project_search', {projectCode, includeIncomplete});
}

//#endregion

//#region Hours Category
export const getD365HoursCategories = async () => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(() => {
                    resolve(require('./mock-data/d365_hours_category.json'));
                });
            }, 200);
        });
    }

    return await get(`/d365_get_hours_categories`);
};

export const createD365HoursCategory = async (categoryName, categoryCode) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 200);
        });
    }

   return await post(`/d365_create_hours_category`, {
        ID: 0,
        categoryName: categoryName,
        categoryCode: categoryCode
    });
};

export const updateD365HoursCategory = async (id, categoryName, categoryCode) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 200);
        });
    }

    return await put(`/d365_update_hours_category`, {
        ID: id,
        categoryName: categoryName,
        categoryCode: categoryCode
    });
};

export const deleteD365HoursCategory = async (id, categoryName, categoryCode) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 200);
        });
    }

    return await del(`/d365_delete_hours_category`, {
        ID: id,
        categoryName: categoryName,
        categoryCode: categoryCode
    });
};
//#endregion

//#region Expenses
export const getD365Expenses = async () => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(() => {
                    resolve(require('./mock-data/d365_expenses.json'));
                });
            }, 200);
        });
    }

    return await get(`/d365_get_expenses`);
};

export const uploadD365ExpensesFile = async (csvData) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 200);
        });
    }

    return await post(`/d365_upload_expenses_file`, { content: csvData });
};

export const listD365ExpenseFiles = async () => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 200);
        });
    }

    return await get(`/d365_list_expense_files`);
};

export const downloadD365ExpenseFile = async (filename) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 200);
        });
    }

    const res = await post(`/d365_download_expense_file`, { filename });
    return await res.json();

};
//#endregion


//#region Expense Code
export const getD365ExpenseCodes = async () => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(() => {
                    resolve(require('./mock-data/d365_expense_codes.json'));
                });
            }, 200);
        });
    }

    return await get(`/d365_get_expense_codes`);
};

export const createD365ExpenseCode = async (code, email) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 200);
        });
    }

    return await post(`/d365_create_expense_code`, {
        ID: 0,
        code: code,
        email: email
    });
};

export const deleteD365ExpenseCode = async (id, email) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 200);
        });
    }

    return await del(`/d365_delete_expense_code`, {
        ID: id,
        code: "",
        email: email
    });
};
//#endregion

//#region Expense Type
export const getD365ExpenseTypes = async () => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(() => {
                    resolve(require('./mock-data/d365_expense_types.json'));
                });
            }, 200);
        });
    }

    return await get(`/d365_get_expense_types`);
};

export const syncD365ExpenseTypes = async () => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(() => {
                    resolve(require('./mock-data/d365_expense_types_sync.json'));
                });
            }, 200);
        });
    }
    return await post('/d365_sync_expense_types');
}
//#endregion

//#region Expense Mapping
export const getD365ExpenseMappings = async () => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(() => {
                    resolve(require('./mock-data/d365_expense_mappings.json'));
                });
            }, 200);
        });
    }

    return await get(`/d365_get_expense_mappings`);
};

export const createD365ExpenseMapping = async (codeId, typeId, email) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 200);
        });
    }

    return await post(`/d365_create_expense_mapping`, {
        ID: 0,
        CodeId: codeId,
        TypeId: typeId,
        Email: email,
    });
};

export const deleteD365ExpenseMapping = async (id, email) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 200);
        });
    }

    return await del(`/d365_delete_expense_mapping`, {
        ID: id,
        Code: "",
        Type: "",
        TypeUID: "",
        Email: email,
    });
};
//#endregion

//#region Unfound Project
export const getD365UnfoundProjects = async () => {
    let unfoundProjects = [];
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(require('./mock-data/d365_unfound_projects.json'));
            }, 200);
        });
    } else {
        unfoundProjects = await get(`/d365_get_unfound_projects`);
    }
    return unfoundProjects;
}

export const deleteD365UnfoundProject = async (id, email) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 200);
        });
    }

    return await del(`/d365_delete_unfound_project`, {
        id: id,
        email: email,
    });
}

export const createD365UnfoundProject = async (projectCode, action, mapProjectCode, email) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 200);
        });
    }

    return await post(`/d365_create_unfound_project`, {
        projectCode: projectCode,
        action: action,
        mapProjectCode: mapProjectCode,
        email: email
    });
};

export const updateD365UnfoundProject = async (id, action, mapProjectCode,email) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 200);
        });
    }

    return await put(`/d365_update_unfound_project`, {
        id: id,
        action: action,
        mapProjectCode: mapProjectCode,
        email: email
    });
};
//#endregion

//#region Rate Codes
export const getD365RateCodes = async () => {
  let rateCodes = [];

  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(require('./mock-data/d365_rate_codes.json'));
      }, 200);
    });
  } else {
    rateCodes = await get(`/d365_get_rates`);
  }

  return rateCodes;
};
//#endregion

//#region Workers
export const getD365Workers = async () => {
    let workers = [];

    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(require('./mock-data/d365_workers.json'));
            }, 200);
        });
    } else {
        workers = await get(`/d365_get_workers`);
    }

    return workers;
};
//#endregion

//#region Adjustments Uploads
export const getD365Uploads = async () => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(require('./mock-data/d365_uploads.json'));
            }, 200);
        });
    } else {
        return await get(`/d365_get_uploads`);
    }
};

export const undoD365Upload = async (id) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 1000);
        });
    }
    const res = await post(`/d365_undo_upload`, {id});
    return await res.json();
}

export const uploadD365AdjustmentsFile = async (xlsxData, name) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 200);
        });
    }

    return await post(`/d365_upload_adjustments_file`, {
        content: xlsxData,
        name: name
    });
};

export const getD365Adjustments = async (id) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(require('./mock-data/d365_adjustments.json'));
            }, 200);
        });
    } else {
        const res = await post(`/d365_get_adjustments`, {id: id});
        return res.json();
    }
};
//#endregion

//#region Payments
export const getD365Payments = async () => {
    let payments = [];

    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(require('./mock-data/d365_payments.json'));
            }, 200);
        });
    } else {
        payments = await get(`/d365_get_payments`);
    }

    return payments;
};

export const updateD365PaymentStatus = async (id, status) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 1000);
        });
    }

    return await put(`/d365_update_payment_status`, {
        id,
        status
    });
};

export const changeD365PaymentInvoice = async (id, invoice) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    status: 200
                });
            }, 1000);
        });
    }

    return await put(`/d365_change_payment_invoice`, {
        id,
        invoice
    });
};

export const uploadD365PaymentsFile = async (csvData) => {
    if (localMode) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, 200);
        });
    }

    return await post(`/d365_upload_payments_file`, { content: csvData });
};


//#endregion
